module.exports = __webpack_public_path__ + "gn.svg?1bfbadf5a9b718973177e9d1c408729f";